import React, { Component } from "react";
import Title from "../../../Helpers/Title";
import { Grid, Icon, Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@material-ui/core";
import WideButton from "../../../Helpers/WideButton";
import PropTypes from "prop-types";
import { isArray } from 'util';

class Filter {
    constructor( name, selector, enabled ) {
        this.name = name;
        this.selector = selector;
        this.enabled = Boolean( enabled );
    }
}

export default class MatchController extends Component {

    static propTypes = {
        matches: PropTypes.array.isRequired,
        setFavorite: PropTypes.func.isRequired
    }

    constructor( props ) {
        super( props );
        this.handleFilterSelectOpen = this.handleFilterSelectOpen.bind( this );
        this.handleFilterSelectClose = this.handleFilterSelectClose.bind( this );
        this.handlePropertyFilterClick = this.handlePropertyFilterClick.bind( this );
        this.handleTenantFilterClick = this.handleTenantFilterClick.bind( this );
    }

    state = {
        // favoriteMatches: [],
        showFavorites: false,
        aboveMatches: [],
        showAbove: false,
        open: false,
        buttonPressed: false,
        propertyFilters: [
            new Filter( "Above 60%", m => m.points >= 60 ),
            new Filter( "Under 1.5 km", m => m.distance <= 1500 ),
            new Filter( "Personality Matches", m => m.personPoints > 3 )
        ],
        tenantFilters: [
            new Filter( "Above 60%", m => m.points >= 60 ),
            new Filter( "Working", m => m.potentialTenant&&m.potentialTenant.occupation ? m.potentialTenant.occupation.work : false ),
            new Filter( "Student", m => m.potentialTenant&&m.potentialTenant.occupation ? m.potentialTenant.occupation.student : false )
        ]
    }

    handleClick = async () => {
        if (!this.state.buttonPressed) {
            this.setState({
                // favoriteMatches: await this.props.getFavorites(),
                buttonPressed: true,
                showFavorites: true
            })
            setTimeout(()=>this.setState({buttonPressed:false}),200)
        }
    }
    handleHideFavorites = async () => {
        if (!this.state.buttonPressed) {
        this.setState({
            buttonPressed: true,
            showFavorites: false
        })
            setTimeout(()=>this.setState({buttonPressed:false}),200)
        }
    }
    // handleAbove = async () => {
    //     const aboveMatches = this.props.matches.filter(match => {
    //         if(match.points > 60) {
    //             return match
    //         } else {
    //             return false
    //         }
    //     })
    //     this.setState({
    //         showAbove: !this.state.showAbove,
    //         aboveMatches
    //     })
    // }

    // handleHideAbove = async () => {
    //     this.setState({
    //         showAbove: !this.state.showAbove
    //     })
    // }

    handleFilterSelectOpen() {
        this.setState({ open: true });
    }

    handleFilterSelectClose() {
        this.setState({ open: false });
    }

    handlePropertyFilterClick( name, enabled ) {
        this.setState( state => {
            let index;
            const oldFilters = state.propertyFilters;
            for ( let i = 0; i < oldFilters.length; i++ ) {
                if ( oldFilters[i].name === name ) {
                    index = i;
                    break;
                }
            }
            return {
                propertyFilters: [
                    ...oldFilters.slice( 0, index ),
                    new Filter( oldFilters[index].name, oldFilters[index].selector, enabled ),
                    ...oldFilters.slice( index + 1, oldFilters.length )
                ]
            }
        } );
    }

    handleTenantFilterClick( name, enabled ) {
        this.setState( state => {
            let index;
            const oldFilters = state.tenantFilters;
            for ( let i = 0; i < oldFilters.length; i++ ) {
                if ( oldFilters[i].name === name ) {
                    index = i;
                    break;
                }
            }
            return {
                tenantFilters: [
                    ...oldFilters.slice( 0, index ),
                    new Filter( oldFilters[index].name, oldFilters[index].selector, enabled ),
                    ...oldFilters.slice( index + 1, oldFilters.length )
                ]
            }
        } );
    }

    render() {
        const { landlord, setFavorite, listComponent } = this.props;
        let {matches } = this.props
        if(Array.isArray(matches)) {
            matches = matches.filter(match => match.distance < 3000)
        }
        const MatchList = listComponent;
        let filteredMatches = matches.slice();
        if ( !landlord ) {
            for ( let i = 0; i < this.state.propertyFilters.length; i++ ) {
                const filter = this.state.propertyFilters[i];
                if ( filter.enabled )
                    filteredMatches = filteredMatches.filter( filter.selector );
            }
        }
        if ( landlord ) {
            for ( let i = 0; i < this.state.tenantFilters.length; i++ ) {
                const filter = this.state.tenantFilters[i];
                if ( filter.enabled )
                    filteredMatches = filteredMatches.filter( filter.selector );
            }
        }
        let favoriteMatches = matches.slice().filter(match => match.favorite);
        console.log( "Matches >>", matches ); // DEBUG
        return (
            <div>
                <Dialog
                    open={this.state.open}
                    disableBackdropClick={false}
                    onBackdropClick={this.handleFilterSelectClose}
                    onEscapeKeyDown={this.handleFilterSelectClose}
                >
                    <DialogTitle>
                        Select a filter
                    </DialogTitle>
                    <DialogContent>
                        <Grid container direction="column" alignItems="stretch">
                            {
                                !landlord &&
                                this.state.propertyFilters.map( filter => (
                                    <WideButton
                                        key={filter.name}
                                        variant="outlined"
                                        color={filter.enabled ? "primary" : "secondary"}
                                        size="large"
                                        onClick={() => this.handlePropertyFilterClick( filter.name, !filter.enabled )}
                                    >
                                        {filter.name}
                                    </WideButton>
                                ) )
                            }
                            {
                                landlord &&
                                this.state.tenantFilters.map( filter => (
                                    <WideButton
                                        key={filter.name}
                                        variant="outlined"
                                        color={filter.enabled ? "primary" : "secondary"}
                                        size="large"
                                        onClick={() => this.handleTenantFilterClick( filter.name, !filter.enabled )}
                                    >
                                        {filter.name}
                                    </WideButton>
                                ) )
                            }
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={this.handleFilterSelectClose}
                            color="secondary"
                        >
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
                {
                this.props.showMatchesOnly ?
                null :
                <div>
                    <Grid container direction="row" justify="space-between" alignItems="center">
                    <Title bigTitle={true} title="Your Potential Matches"/>
                    <div>
                        {
                            !landlord &&
                            <WideButton
                            variant="outlined"
                            color={this.state.showFavorites? "primary" :"secondary"}
                            onClick={this.state.showFavorites? this.handleHideFavorites: this.handleClick}
                            >
                                {this.state.showFavorites? 'View potential matches' : 'Favourite Potential Matches'}
                            </WideButton>
                        }
                        {/*<WideButton
                            variant="outlined"
                            color="secondary"
                        >
                            <Icon>map</Icon> Map View
                         </WideButton>*/}
                    </div>
                	</Grid>
                    <Grid container direction="row" justify="flex-start" alignItems="center">
                            {/* <Icon>filter_list</Icon> */}
                            {/* <WideButton
                                    variant="outlined"
                                    color={this.state.showAbove? "primary" :"secondary"}
                                    onClick={!this.state.showAbove? this.handleAbove: this.handleHideAbove}
                            >
                                    Above 60%
                            </WideButton> */}
                            <WideButton
                                variant="contained"
                                color="secondary"
                                onClick={this.handleFilterSelectOpen}
                            >
                                Select filter
                            </WideButton>
                            {
                                !landlord &&
                                this.state.propertyFilters.filter( f => f.enabled ).map( filter => {
                                    return (
                                        <WideButton
                                            key={filter.name}
                                            variant="outlined"
                                            color="primary"
                                            onClick={() => this.handlePropertyFilterClick( filter.name, false )}
                                        >
                                            {filter.name}
                                        </WideButton>
                                    )
                                } )
                            }
                            {
                                landlord &&
                                this.state.tenantFilters.filter( f => f.enabled ).map( filter => {
                                    return (
                                        <WideButton
                                            key={filter.name}
                                            variant="outlined"
                                            color="primary"
                                            onClick={() => this.handleTenantFilterClick( filter.name, false )}
                                        >
                                            {filter.name}
                                        </WideButton>
                                    )
                                } )
                            }
                    </Grid>
                    </div>
                }
                {/* <MatchList setFavorite={setFavorite} matches={this.state.showFavorites? this.state.favoriteMatches: this.state.showAbove? this.state.aboveMatches : matches}/> */}
                <MatchList
                    setFavorite={setFavorite}
                    matches={this.state.showFavorites ? favoriteMatches : filteredMatches}
                />
            </div>
        );
    }

}